/**
 * Resolve the rendered state of a maker on/off switch (Poly / Kalshi) on the
 * opener row.
 *
 * A maker toggle fires up to three sequential PATCHes behind the scenes
 * (auto-enable the pair → create the rule → set the flag). Binding the switch
 * straight to the rule's flag made it look frozen until that whole chain
 * settled ("no cambia hasta después"). Instead the click records an optimistic
 * `pending` value synchronously; this helper makes the switch reflect it
 * immediately and lock against double-clicks until the mutation settles, at
 * which point `pending` is cleared and the switch hands off to server truth.
 *
 * - `pending === undefined` → no in-flight toggle; show the rule's flag.
 * - `pending` set → show the clicked value and disable until it clears.
 * - `activationBlocked` (ungrouped pair, arming) always disables.
 */
export function resolveMakerSwitchState(opts: {
  pending: boolean | undefined;
  makerOn: boolean;
  activationBlocked: boolean;
}): { checked: boolean; disabled: boolean } {
  const { pending, makerOn, activationBlocked } = opts;
  return {
    checked: pending ?? makerOn,
    disabled: activationBlocked || pending !== undefined,
  };
}
